module.exports = __webpack_public_path__ + "static/logo_small-ffb71d933299a19ddb702bad6d4ba894.png";